module.exports = __webpack_public_path__ + "202408221624/img/bainian.aeff6362.png";